var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSweetheartList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44444 4.22217H6.22222C5.63286 4.22217 5.06762 4.45629 4.65088 4.87305C4.23412 5.28979 4 5.85502 4 6.44439V19.7777C4 20.3671 4.23412 20.9323 4.65088 21.3491C5.06762 21.7658 5.63286 21.9999 6.22222 21.9999H17.3333C17.9227 21.9999 18.4879 21.7658 18.9047 21.3491C19.3214 20.9323 19.5556 20.3671 19.5556 19.7777V6.44439C19.5556 5.85502 19.3214 5.28979 18.9047 4.87305C18.4879 4.45629 17.9227 4.22217 17.3333 4.22217H15.1111M11.7778 11.9999H15.1111M11.7778 16.4444H15.1111M8.44444 11.9999H8.45556M8.44444 16.4444H8.45556",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93261 2.4766C8.77786 2.62769 8.65508 2.80708 8.57132 3.00449C8.48757 3.20191 8.44446 3.4135 8.44446 3.62719C8.44446 3.84088 8.48757 4.05247 8.57132 4.24989C8.65508 4.44731 8.77786 4.62669 8.93261 4.77779L11.7778 7.55556L14.623 4.77779C14.9356 4.47263 15.1111 4.05874 15.1111 3.62719C15.1111 3.19563 14.9356 2.78176 14.623 2.4766C14.3105 2.17144 13.8865 2 13.4445 2C13.0024 2 12.5785 2.17144 12.2659 2.4766L11.7778 2.95318L11.2896 2.4766C11.1349 2.3255 10.9511 2.20563 10.7489 2.12387C10.5467 2.04209 10.33 2 10.1111 2C9.89226 2 9.67554 2.04209 9.47332 2.12387C9.27111 2.20563 9.08738 2.3255 8.93261 2.4766Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSweetheartList);
export default __webpack_public_path__ + "static/media/icon-sweetheart-list.d53196b0285dfd8af6b83f7bbac66068.svg";
export { ForwardRef as ReactComponent };